import React from 'react';

// Static pastel neon gradient — pink / purple / blue.
//
// The previous version layered 3 huge slowly-drifting blurred blobs on top
// of this base layer to create a "breathing" gradient. The user preferred
// the calmer, fully-static look that the title bar uses (the same colours
// without the motion), so we now render only the static floor — the
// title-bar `::before` and this floor share the exact same gradient stack,
// which guarantees the title strip blends seamlessly with the rest of the
// page background regardless of scroll position.
export const BackgroundGradient = () => (
  <div className="bg-stage" aria-hidden="true" data-testid="background-gradient">
    <div className="bg-stage__floor" />
  </div>
);
